module.exports = __webpack_public_path__ + "img/cover-3.c9282d54.jpg";